import axios from "axios";
import { toast } from "react-toastify";
export const GetAllProjectCat = (data) => {
  return {
    type: "get_allprojectcat",
    payload: data,
    loader: false,
  };
};
export function getallProjectCat() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Projects/ProjectCategories`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllProjectCat(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
